import { ICreateWatchContext } from './createWatchContext';

export enum CreateWatchActionTypes {
	CHANGE_SERIAL_NUMBER = 'CHANGE_SERIAL_NUMBER',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeSerialNumber {
	type: CreateWatchActionTypes.CHANGE_SERIAL_NUMBER;
	payload: {
		serialNumber: ICreateWatchContext['serialNumber'];
	};
}

interface ISetIDCustomer {
	type: CreateWatchActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateWatchContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: CreateWatchActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: ICreateWatchContext['IDSelectedRestaurant'];
	};
}

interface ISetDataForSubmit {
	type: CreateWatchActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateWatchContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateWatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateWatchContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: CreateWatchActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: ICreateWatchContext['errorResponseData'];
	};
}

interface IResetSelectedControls {
	type: CreateWatchActionTypes.RESET_FIELDS;
}

export type TCreateWatchAction =
	| IChangeSerialNumber
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
